import { render } from "./ConfirmationDialogue.vue?vue&type=template&id=19badb37"
import script from "./ConfirmationDialogue.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogue.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__